import type { ComponentProps } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { GlobalDropdown } from './GlobalDropdown';

export const ThreeDotsDropdown = ({
  children,
  isDropdownOpen,
  setIsDropdownOpen,
  triggerProps,
  dropdownProps: { align = 'start', ...dropdownProps } = {},
  isModal = false,
  variant,
  disabled = false,
}: {
  children: React.ReactNode;
  isDropdownOpen: boolean;
  setIsDropdownOpen: (isDropdownOpen: boolean) => void;
  triggerProps?: Partial<ComponentProps<typeof IconButton>>;
  dropdownProps?: Partial<ComponentProps<typeof GlobalDropdown>>;
  isModal?: boolean; // used to display this dropdown as a modal
  variant?: ComponentProps<typeof IconButton>['variant'];
  disabled?: boolean;
}) => {
  return (
    <GlobalDropdown
      onOpenChange={() => (disabled ? null : setIsDropdownOpen(!isDropdownOpen))}
      isModal={isModal}
      wrapperContentProps={{
        css: {
          zIndex: '$modalDropdown',
        },
      }}
      trigger={
        <IconButton
          variant={variant}
          onClick={e => e.stopPropagation()}
          className="three-dots-icon"
          icon={<FontAwesomeIcon icon={faEllipsis} size="lg" />}
          disabled={disabled}
          {...triggerProps}
        />
      }
      align={align}
      {...dropdownProps}
    >
      {children}
    </GlobalDropdown>
  );
};
